<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" alt="Creole Rendezvous gallery image" />
  </ng-template>
</p-galleria>

<div
  class="innerBanner specialInterestBanner"
  [style.background-image]="'url(' + creSpecialIntrest.bannerImage + ')'"
  style="cursor: pointer"
  (click)="imageClick(0)"
>
  <!-- <div class="bannerText">
    <h1 [attr.data-before-content]="beforeHeadingContent">{{ creSpecialIntrest.bannerTitle }}</h1>
  </div> -->
  <div class="mouse_scroll" (click)="scollBottom()">
    <div class="mouse">
      <div class="wheel"></div>
    </div>
    <div>
      <span class="m_scroll_arrows unu"></span>
      <span class="m_scroll_arrows doi"></span>
      <span class="m_scroll_arrows trei"></span>
    </div>
  </div>
</div>

<div class="container contentPanel">
  <!-- <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/home">Home</a></li>
      <li class="breadcrumb-item"><a href="/special_interest/culture">Culture</a></li>
      <li class="breadcrumb-item active" aria-current="page">Creole Rendezvous</li>
    </ol>
  </nav> -->
  <app-breadcrumb-row></app-breadcrumb-row>
  <div class="pageTitle mt-5">
    <p [innerHTML]="creSpecialIntrest.bannerContent"></p>
  </div>
</div>
<div class="container creoleFilter">
  <div class="tabTitle">{{ 'Authentic Creole Products' | translate }}</div>
  <div class="tabs">
    <div
      class="tab"
      *ngFor="let cat of creoleCategories; let i = index"
      (click)="onCategoryClick(cat.value, i)"
      [class.active]="activeIndex === i"
    >
      {{ cat.label | translate }}
    </div>
  </div>
</div>
<div class="container">
  <div class="contentPanel">
    <div *ngFor="let list of filteredCategories">
      <h1>{{ list.bannerTitle }}</h1>
      <p [innerHTML]="list.content"></p>
    </div>
    <div class="accomListPanel">
      <div class="p-grid justify-content-between mt-4 mb-3">
        <div class="" style="padding: 15px !important">
          <div class="">
            <span style="color: red">{{ totalRecords }}</span> {{ 'Results were found' | translate }}
          </div>
        </div>
        <div class="d-none d-sm-none d-md-block">
          <p-selectButton
            [options]="tourOperatorOptions"
            (onChange)="tourOperatorOptionChanged(tourOperatorOptionSelected)"
            [(ngModel)]="tourOperatorOptionSelected"
            optionValue="code"
          >
            <ng-template let-item>
              <div style="border: none">
                <img [src]="item.imgSel" class="width-18" *ngIf="item.selected" alt="" />
                <img [src]="item.img" class="width-18" *ngIf="!item.selected" alt="" />
                <span>{{ item.name | translate }}</span>
              </div>
            </ng-template>
          </p-selectButton>
          <div class="mt-2 panel-border pt-2" *ngIf="tourOperatorOptionSelected == 2">
            <p-dropdown
              [options]="countries"
              (onChange)="countrySelected()"
              [(ngModel)]="selectedCountry"
              optionLabel="name"
              [filter]="true"
              filterBy="name"
              [showClear]="true"
              placeholder="Select a Country"
            >
              <ng-template pTemplate="selectedItem">
                <div class="country-item country-item-value" *ngIf="selectedCountry && selectedCountry.code">
                  <div>
                    <span class="fi fi-{{ selectedCountry.code.toLowerCase() }}"></span> {{ selectedCountry.name }}
                  </div>
                </div>
              </ng-template>
              <ng-template let-country pTemplate="item">
                <div class="country-item">
                  <div><span class="fi fi-{{ country.code.toLowerCase() }}"></span> {{ country.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        <div class="d-none d-sm-none d-md-block" *ngIf="islandBtns.length > 0">
          <p-selectButton
            [options]="islandBtns"
            (onChange)="islandOptionChanged(islandOptionSelected)"
            [(ngModel)]="islandOptionSelected"
            optionValue="code"
          >
            <ng-template let-item>
              <div style="border: none">
                <img [src]="item.imgSel" class="width-18" *ngIf="item.selected" alt="" />
                <img [src]="item.img" class="width-18" *ngIf="!item.selected" alt="" />
                <span>{{ item.name | translate }}</span>
              </div>
            </ng-template>
          </p-selectButton>
        </div>
        <div class="d-none d-sm-none d-md-block" *ngIf="eventBtns.length > 0">
          <p-selectButton
            [options]="eventBtns"
            (onChange)="eventOptionChanged(eventOptionSelected)"
            [(ngModel)]="eventOptionSelected"
            optionValue="code"
          >
            <ng-template let-item>
              <div style="border: none">
                <img [src]="item.imgSel" class="width-18" *ngIf="item.selected" alt="" />
                <img [src]="item.img" class="width-18" *ngIf="!item.selected" alt="" />
                <span>{{ item.name | translate }}</span>
              </div>
            </ng-template>
          </p-selectButton>
        </div>
        <div class="sortUI sortBy" style="text-align: right">
          <span class="filterMobile"
            ><a
              role="button"
              tabindex="0"
              class="filterBtn"
              (click)="toggleFilter()"
              (keydown.enter)="toggleFilter()"
              (keydown.space)="toggleFilter()"
              ><i class="icon icon-sliders"></i> {{ 'Filters' | translate }}</a
            ></span
          >
          <select id="sort-by" [(ngModel)]="sortValue" placeholder="Sort By" (change)="sort($event.target.value)">
            <option value="" selected disabled hidden>{{ 'Sort By' | translate }}</option>
            <option translate value="A to Z">A to Z</option>
            <option translate value="Z to A">Z to A</option>
            <option translate value="newest" *ngIf="selectedCategorieName != 'EVENT'">Newest</option>
            <option translate value="oldest" *ngIf="selectedCategorieName != 'EVENT'">Oldest</option>
            <option translate value="newest" *ngIf="selectedCategorieName == 'EVENT'">Date Ascending</option>
            <option translate value="oldest" *ngIf="selectedCategorieName == 'EVENT'">Date Descending</option>
            <option translate value="price_low" *ngIf="sortOne === true">Price: Low to High</option>
            <option translate value="price_high" *ngIf="sortOne === true">Price: High to Low</option>
            <!-- <option translate value="rating_low">Rating: Low to High</option>
            <option translate value="rating_high">Rating: High to Low</option> -->
          </select>
        </div>
      </div>
      <!-- Filter Section -->
      <div id="filterSection" class="filterBody">
        <div class="closeFilter" (click)="toggleFilter()">X</div>
        <form name="planyourvisit" class="filterPanel" (ngSubmit)="advanceSearch($event, advanceSearchFilter)">
          <h2><i class="icon icon-sliders"></i> {{ 'Filter Results' | translate }}</h2>
          <div class="panel-border pt-2 d-md-none d-lg-none" *ngIf="tourOperatorOptions.length > 0">
            <p-selectButton
              [options]="tourOperatorOptions"
              (onChange)="tourOperatorOptionChanged(tourOperatorOptionSelected)"
              [(ngModel)]="tourOperatorOptionSelected"
              [ngModelOptions]="{ standalone: true }"
              optionValue="code"
            >
              <ng-template let-item>
                <div style="border: none">
                  <img [src]="item.imgSel" class="width-18" *ngIf="item.selected" alt="" />
                  <img [src]="item.img" class="width-18" *ngIf="!item.selected" alt="" />
                  <span>{{ item.name }}</span>
                </div>
              </ng-template>
            </p-selectButton>
            <ng-container *ngIf="tourOperatorOptionSelected == 2">
              <div class="mt-2 pt-2 panel-border t-2">
                <p-dropdown
                  [options]="countries"
                  [showClear]="true"
                  (onChange)="countrySelected()"
                  [(ngModel)]="selectedCountry"
                  [ngModelOptions]="{ standalone: true }"
                  optionLabel="name"
                  [filter]="true"
                  filterBy="name"
                  placeholder="Select a Country"
                >
                  <ng-template pTemplate="selectedItem">
                    <div class="country-item country-item-value" *ngIf="selectedCountry && selectedCountry.code">
                      <div>
                        <span class="fi fi-{{ selectedCountry.code.toLowerCase() }}"></span> {{ selectedCountry.name }}
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-country pTemplate="item">
                    <div class="country-item">
                      <div><span class="fi fi-{{ country.code.toLowerCase() }}"></span> {{ country.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </ng-container>
          </div>
          <div class="panel-border pt-2 d-md-none d-lg-none" *ngIf="islandBtns.length > 0">
            <p-selectButton
              [options]="islandBtns"
              (onChange)="islandOptionChanged(islandOptionSelected)"
              [(ngModel)]="islandOptionSelected"
              optionValue="code"
              [ngModelOptions]="{ standalone: true }"
            >
              <ng-template let-item>
                <div style="border: none">
                  <img [src]="item.imgSel" class="width-18" *ngIf="item.selected" alt="" />
                  <img [src]="item.img" class="width-18" *ngIf="!item.selected" alt="" />
                  <span>{{ item.name | translate }}</span>
                </div>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="panel-border pt-2 d-md-none d-lg-none" *ngIf="eventBtns.length > 0">
            <p-selectButton
              [options]="eventBtns"
              (onChange)="eventOptionChanged(eventOptionSelected)"
              [(ngModel)]="eventOptionSelected"
              optionValue="code"
              [ngModelOptions]="{ standalone: true }"
            >
              <ng-template let-item>
                <div style="border: none">
                  <img [src]="item.imgSel" class="width-18" *ngIf="item.selected" alt="" />
                  <img [src]="item.img" class="width-18" *ngIf="!item.selected" alt="" />
                  <span>{{ item.name | translate }}</span>
                </div>
              </ng-template>
            </p-selectButton>
          </div>
          <div class="filterPanelSearch panel-border mt-2">
            <ng-container *ngIf="catCls && isClassifiedSelected && catCls.length > 0">
              <ul>
                <li *ngFor="let cate of catCls; let i = index" (click)="selectedClassification(cate)">
                  <span [ngClass]="{ active: classifications.includes(cate.ProductTypeId) }" *ngIf="i != 7">{{
                    cate.Description
                  }}</span>
                </li>
              </ul>
            </ng-container>
            <p-accordion class="mb-3" *ngIf="selectedClassificationName !== 'ISLANDS'">
              <p-accordionTab header="{{ 'Select Island' | translate }}" [selected]="false">
                <div>
                  <p-listbox
                    [options]="isLandTypes"
                    multiple="multiple"
                    checkbox="checkbox"
                    filter="filter"
                    name="select All"
                    optionLabel="name"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="advanceSearchFilter.landTypes"
                    (onChange)="selectIsLand(selectedIslands)"
                  ></p-listbox>
                </div>
              </p-accordionTab>
            </p-accordion>

            <p-accordion
              class="mb-3"
              *ngIf="selectedCategorieName === 'DESTINFO' && selectedClassificationName === 'ISLANDS'"
            >
              <p-accordionTab header="{{ 'Select Island Type' | translate }}" [selected]="false">
                <div>
                  <p-listbox
                    [options]="landCategory"
                    multiple="true"
                    checkbox="checkbox"
                    [metaKeySelection]="false"
                    [filter]="false"
                    name="select All"
                    optionLabel="name"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="advanceSearchFilter.landCategory"
                    class="landCategory"
                  ></p-listbox>
                </div>
              </p-accordionTab>
            </p-accordion>

            <p-accordion
              *ngIf="
                selectedCategorieName !== 'TOUROPERATOR' &&
                selectedCategorieName !== 'DESTINFO' &&
                selectedCategorieName !== 'ACCOMM'
              "
            >
              <!-- <p-accordionTab header="{{ 'Amenities' | translate }}" [selected]="false"> -->
              <p-accordionTab header="{{ 'Facilities' | translate }}" [selected]="false">
                <div>
                  <p-listbox
                    [options]="amentisTypes"
                    multiple="multiple"
                    checkbox="checkbox"
                    filter="filter"
                    [ngModelOptions]="{ standalone: true }"
                    optionLabel="Description"
                    [(ngModel)]="advanceSearchFilter.amenities"
                  ></p-listbox>
                </div>
              </p-accordionTab>
            </p-accordion>

            <p-accordion *ngIf="selectedCategorieName == 'ACCOMM' && activitiesArr.length > 0">
              <p-accordionTab header="{{ 'Activities' | translate }}" [selected]="false">
                <div>
                  <p-listbox
                    [options]="activitiesArr"
                    multiple="multiple"
                    checkbox="checkbox"
                    filter="filter"
                    [ngModelOptions]="{ standalone: true }"
                    optionLabel="description"
                    [(ngModel)]="advanceSearchFilter.amenities"
                  ></p-listbox>
                </div>
              </p-accordionTab>
            </p-accordion>
            <p-accordion *ngIf="selectedCategorieName == 'ACCOMM' && facilitiesArr.length > 0">
              <p-accordionTab header="{{ 'Facilities' | translate }}" [selected]="false">
                <div>
                  <p-listbox
                    [options]="facilitiesArr"
                    multiple="multiple"
                    checkbox="checkbox"
                    filter="filter"
                    [ngModelOptions]="{ standalone: true }"
                    optionLabel="description"
                    [(ngModel)]="advanceSearchFilter.amenities"
                  ></p-listbox>
                </div>
              </p-accordionTab>
            </p-accordion>
            <p-accordion *ngIf="selectedCategorieName == 'ACCOMM' && roomFacilities.length > 0">
              <p-accordionTab header="{{ 'Room Facilities' | translate }}" [selected]="false">
                <div>
                  <p-listbox
                    [options]="roomFacilities"
                    multiple="multiple"
                    checkbox="checkbox"
                    filter="filter"
                    [ngModelOptions]="{ standalone: true }"
                    optionLabel="description"
                    [(ngModel)]="advanceSearchFilter.amenities"
                  ></p-listbox>
                </div>
              </p-accordionTab>
            </p-accordion>
            <p-accordion *ngIf="selectedCategorieName == 'ACCOMM' && secretsRatings.length > 0">
              <p-accordionTab header="Seychelles {{ 'Secrets Rating' | translate }}" [selected]="false">
                <div>
                  <p-listbox
                    [options]="secretsRatings"
                    multiple="multiple"
                    checkbox="checkbox"
                    [ngModelOptions]="{ standalone: true }"
                    optionLabel="description"
                    [(ngModel)]="advanceSearchFilter.secretsRatings"
                  ></p-listbox>
                </div>
              </p-accordionTab>
            </p-accordion>
            <p-accordion *ngIf="selectedCategorieName == 'ACCOMM' && starRatingValues.length > 0">
              <p-accordionTab header="{{ 'Star Rating' | translate }}" [selected]="false">
                <div>
                  <p-listbox
                    [options]="starRatingValues"
                    multiple="multiple"
                    checkbox="checkbox"
                    [ngModelOptions]="{ standalone: true }"
                    optionLabel="description"
                    [(ngModel)]="advanceSearchFilter.starRatings"
                  ></p-listbox>
                </div>
              </p-accordionTab>
            </p-accordion>
            <p-accordion
              *ngIf="
                (selectedCategorieName == 'ACCOMM' ||
                  selectedCategorieName == 'RESTAURANT' ||
                  selectedCategorieName == 'TOUROPERATOR') &&
                AccreditationsArr.length > 0
              "
            >
              <p-accordionTab header="{{ 'Accreditations' | translate }}" [selected]="false">
                <div>
                  <p-listbox
                    [options]="AccreditationsArr"
                    multiple="multiple"
                    checkbox="checkbox"
                    filter="filter"
                    [ngModelOptions]="{ standalone: true }"
                    optionLabel="description"
                    [(ngModel)]="advanceSearchFilter.amenities"
                  ></p-listbox>
                </div>
              </p-accordionTab>
            </p-accordion>
            <div
              class="filterByPrice"
              *ngIf="minPrice && minPrice.rateFrom !== 1000000000000000000 && maxPrice && maxPrice.rateTo > 0"
              style="position: relative"
            >
              <h3>{{ 'Price Range' | translate }}</h3>
              <p class="minMax pt-1">
                <span [class.minChanged]="minPrice.rateFrom !== advanceSearchFilter.price[0]"
                  >Min <br />
                  SCR{{ advanceSearchFilter.price[0] }}</span
                >
                <span [class.maxChanged]="maxPrice.rateTo !== advanceSearchFilter.price[1]"
                  >Max <br />
                  SCR{{ advanceSearchFilter.price[1] }}</span
                >
              </p>
              <p-slider
                [(ngModel)]="advanceSearchFilter.price"
                [ngModelOptions]="{ standalone: true }"
                [range]="true"
                [min]="minPrice.rateFrom"
                [max]="maxPrice.rateTo"
                class="priceRange"
              ></p-slider>
              <!-- <p style="margin-top: 10px" class="priceRanges">{{ advanceSearchFilter.price[0] }} - {{ advanceSearchFilter.price[1] }}</p> -->
            </div>
            <div *ngIf="minPrice && minPrice.rateFrom !== 1000000000000000000 && maxPrice && maxPrice.rateTo > 0">
              <div
                class="d-flex panel-border pt-2 pb-2"
                *ngIf="minPrice && minPrice.rateFrom !== 1000000000000000000 && maxPrice && maxPrice.rateTo > 0"
              >
                <div class="pt-2 p-r-75"><label for="minInput" style="color: #00a7a6">Min</label></div>
                <div class="min-max-input">
                  <p-inputNumber
                    inputId="minInput"
                    [(ngModel)]="advanceSearchFilter.price[0]"
                    [ngModelOptions]="{ standalone: true }"
                    mode="currency"
                    currency="SCR"
                    currencyDisplay="code"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="0"
                    [min]="0"
                  ></p-inputNumber>
                </div>
                <!-- <input type="number" id="minInput" [(ngModel)]="advanceSearchFilter.price[0]" [ngModelOptions]="{ standalone: true }"
                  [min]="0" /> -->
              </div>
              <div class="d-flex panel-border pt-2 pb-2">
                <div class="pt-2 pr-2"><label for="maxInput" style="color: #00a7a6">Max</label></div>
                <div class="min-max-input">
                  <p-inputNumber
                    inputId="maxInput"
                    [(ngModel)]="advanceSearchFilter.price[1]"
                    [ngModelOptions]="{ standalone: true }"
                    mode="currency"
                    currency="SCR"
                    currencyDisplay="code"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="0"
                    [min]="0"
                  ></p-inputNumber>
                  <!-- <input type="number" id="maxInput" [(ngModel)]="advanceSearchFilter.price[1]" [ngModelOptions]="{ standalone: true }"
                  [min]="0" /> -->
                </div>
              </div>
            </div>
          </div>

          <div class="filterButtons">
            <button type="submit" class="btn btn-primary btn-lg">{{ 'Apply Filters' | translate }}</button>
            <button type="button" class="btn btn-outline-primary btn-lg" (click)="restChange()">
              {{ 'Clear Filters' | translate }}
            </button>
          </div>
        </form>
      </div>
      <!-- Filter Section -->

      <div class="p-grid accommodationGrid">
        <div class="p-lg-12" style="padding: 15px !important">
          <!-- <p-progressSpinner [hidden]="searchResults.length != 0"></p-progressSpinner> -->
          <div class="p-grid" #productsList>
            <ng-container *ngFor="let item of searchResults">
              <div class="p-col-12 p-md-6 p-lg-3" *ngIf="item.showItem">
                <p-card>
                  <ng-template pTemplate="header">
                    <span class="eventDate" *ngIf="item.startDate && item.startDate != 'none'">
                      {{ item.startDate | date: 'MMM d' | uppercase }}<sup>{{ item.startRm }}</sup>
                      <span *ngIf="item.endDate != 'none'">
                        - {{ item.endDate | date: 'MMM d' | uppercase }}<sup>{{ item.endRm }}</sup></span
                      >
                    </span>
                    <div>
                      <a target="_blank" class="product-item alisting" [href]="'/listingdetails/' + item.productId">
                        <img class="CategoriesImages" [alt]="item.productName" [src]="item.productImage"
                      /></a>
                      <div *ngIf="item.rateFrom" class="accomodationPrice">
                        <a target="_blank" class="product-item alisting" [href]="'/listingdetails/' + item.productId">
                          <div class="price">
                            <h3>{{ 'starting from' | translate }}</h3>
                            SCR {{ item.rateFrom | number }}
                            <!-- - SCR {{ item.rateTo }} -->
                          </div>
                        </a>
                      </div>

                      <!-- <span class="wishlistHeart" (click)="$event.stopPropagation()">
                          <a (click)="addToWhishList(item)"
                            ><i class="fa fa-heart wishlist" [style.color]="item.color ? item.color : '#fff'"></i
                          ></a>
                        </span> -->
                      <div *ngIf="item.productCategoryId === 'EVENT'; else eventWishlistHeart">
                        <span class="eventWishlistHeart" (click)="$event.stopPropagation()">
                          <a
                            role="button"
                            tabindex="0"
                            [attr.aria-label]="'Add to wishlist' | translate"
                            (click)="addToWhishList(item)"
                            (keydown.enter)="addToWhishList(item)"
                            ><i class="fa fa-heart wishlist" [style.color]="item.color ? item.color : '#fff'"></i
                          ></a>
                        </span>
                      </div>
                      <ng-template #eventWishlistHeart>
                        <span class="wishlistHeart" (click)="$event.stopPropagation()">
                          <a
                            role="button"
                            tabindex="0"
                            [attr.aria-label]="'Add to wishlist' | translate"
                            (click)="addToWhishList(item)"
                            (keydown.enter)="addToWhishList(item)"
                            ><i class="fa fa-heart wishlist" [style.color]="item.color ? item.color : '#fff'"></i
                          ></a>
                        </span>
                      </ng-template>
                    </div>

                    <!-- <div class="accBookMark">
                        <img *ngFor="let accr of item.accredations" [src]="accr" />
                      </div> -->
                    <div>
                      <ng-container *ngFor="let accr of item.accredations">
                        <!-- Create a span for each image tag -->
                        <span class="accBookMarkSpan">
                          <img
                            [src]="accr"
                            class="accBookMarkSpanImg"
                            [pTooltip]="isSustainableSeychelles(accr) ? sstlText(item, accr) : null"
                            [escape]="false"
                            tooltipPosition="bottom"
                            alt=""
                          />
                        </span>
                      </ng-container>
                    </div>
                  </ng-template>
                  <a target="_blank" class="product-item alisting" [href]="'/listingdetails/' + item.productId">
                    <div class="locationTitle">
                      <div class="d-flex justify-content-between">
                        <div>
                          <ng-container *ngFor="let classification of item.classification">
                            <div class="locationName list-comma" *ngIf="classification !== ''">
                              <span [innerHTML]="classification"></span>
                            </div>
                          </ng-container>
                        </div>
                        <div>
                          <img
                            [pTooltip]="secrateRatingText(item)"
                            [escape]="false"
                            tooltipPosition="bottom"
                            *ngIf="selectedCategorieName == 'ACCOMM' && item.secrateRating == 'BRONZE'"
                            src="/assets/images/bronze.svg"
                            width="30"
                            height="30"
                            alt="Bronze rating"
                          />
                          <img
                            [pTooltip]="secrateRatingText(item)"
                            [escape]="false"
                            tooltipPosition="bottom"
                            *ngIf="selectedCategorieName == 'ACCOMM' && item.secrateRating == 'GOLD'"
                            src="/assets/images/Gold.svg"
                            width="30"
                            height="30"
                            alt="Gold rating"
                          />
                          <img
                            [pTooltip]="secrateRatingText(item)"
                            [escape]="false"
                            tooltipPosition="bottom"
                            *ngIf="selectedCategorieName == 'ACCOMM' && item.secrateRating == 'SILVER'"
                            src="/assets/images/Silver.svg"
                            width="30"
                            height="30"
                            alt="Silver rating"
                          />

                          <div *ngIf="selectedCategorieName == 'ACCOMM' && item.starRating >= 0">
                            <div [pTooltip]="starRatingText(item)" [escape]="false" tooltipPosition="bottom">
                              <p-rating [(ngModel)]="item.starRating" [cancel]="false" readonly="true"></p-rating>
                            </div>
                          </div>
                        </div>
                      </div>
                      <h5>{{ item.productName }}<i class="icon-safe"></i></h5>

                      <div class="locationName" *ngIf="item.island">
                        <i class="icon-location"></i>{{ item.addresses[0].islandArea
                        }}<span *ngIf="item.island && item.addresses[0].islandArea">,&nbsp;</span>{{ item.island }}
                      </div>
                      <!-- <div class="viewmore">
                          <span class="p-button-text" (click)="viewMoreDetils(item.productId)">{{
                            'View Details' | translate
                          }}</span>
                        </div> -->
                    </div>
                  </a>
                </p-card>
              </div>
            </ng-container>
          </div>
          <div class="row mt-10">
            <div class="col-md-12 text-center" *ngIf="isViewMoreRecords">
              <a
                role="button"
                tabindex="0"
                class="btn btn-primary btn-lg"
                (click)="ViewMoreRecord()"
                (keydown.enter)="ViewMoreRecord()"
                >{{ 'View more' | translate }} <i class="glyphicon glyphicon-plus"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container contentPanel" *ngIf="filteredData && filteredData.length > 0">
  <div class="placesToSee blog" *ngIf="videoProducts && videoProducts.length > 0">
    <h1 class="text-center" style="color: #00a7a6">{{ 'UNWTOAwardwinningvideo' | translate }}</h1>
    <div class="latestvideos-flipster">
      <ul>
        <li *ngFor="let product of videoProducts" [id]="'q' + product">
          <div [id]="product" class="pvideos"></div>
        </li>
      </ul>
    </div>
    <div class="text-right" *ngIf="videoProducts">
      <!-- <button type="button" class="video-nav-button" (click)="prev()"><i class="pi pi-chevron-left"></i></button>
      <button type="button" class="video-nav-button" (click)="next()"><i class="pi pi-chevron-right"></i></button> -->
      <button type="button" class="video-nav-button left" (click)="prev()">
        <i class="stb-icon">&#xe820;</i>
      </button>
      <button type="button" class="video-nav-button right" (click)="next()">
        <i class="stb-icon">&#xe81f;</i>
      </button>
    </div>
  </div>

  <div class="placesToSee blog">
    <h1 class="text-center">#{{ 'CreoleRendezvous' | translate }}</h1>
    <div class="creole" #creole></div>
  </div>

  <p-toast position="top-center" key="add-wishlist" [baseZIndex]="15000"></p-toast>
  <div class="np-loader" *ngIf="showLoader">
    <p-progressSpinner strokeWidth="5"></p-progressSpinner>
  </div>
</div>
